<template>
  <div id="coupons">
    <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>优惠券管理&nbsp;/&nbsp;优惠券列表</span>
        </div>
        <div style="display: flex;flex-wrap: wrap;align-items: center;">
            <Provinces @gain='gainSS'></Provinces>
           <el-input class="elinputs" v-model="beginData.discount" placeholder="金额"></el-input>
           <el-input class="elinputs" v-model="beginData.id" placeholder=" 搜索编号"></el-input>
            <el-button type="primary" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0.4)" v-loading.fullscreen.lock="fullscreenLoading" @click="query">查询</el-button>
            <el-button type="info" @click='resets'>重置</el-button>
        </div>
        <div class="tit">
            <Reset @clkBtn='theBtn'></Reset>
            <Xlsx :name="formname"></Xlsx>
        </div>
        <el-table :data="tableData" id="exportTab" @selection-change="handleSelectionChange" border stripe style="width: 100%">
        <el-table-column type="selection" width="60"></el-table-column>
        <el-table-column type="index" label="序号" width="80" :index="1"></el-table-column>
        <el-table-column prop="discount" label="金额" sortable width="100"></el-table-column>
        <el-table-column prop="min" label="门槛金额" sortable width="120"></el-table-column>
        <el-table-column prop="total" label="数量" sortable width="100"></el-table-column>
        <el-table-column prop="areasName" label="所属地区" min-width="160"></el-table-column>

        <el-table-column prop="receiveNum" label="已领取数量" sortable width="160"></el-table-column>
        <el-table-column prop="useNum" label="已使用数量" sortable width="160"></el-table-column>
        <el-table-column prop="receiveStartTime" label="领取开始时间" width="180"></el-table-column>
        <el-table-column prop="receiveEndTime" label="领取结束时间" width="180"></el-table-column>
        <el-table-column prop="startTime" label="使用开始时间" width="180"></el-table-column>
        <el-table-column prop="endTime" label="使用结束时间" width="180"></el-table-column>

        <el-table-column label="是否上架" width="160">
            <template slot-scope="scope">
                <p class="boldfont" v-if="scope.row.isShelf">已上架</p>
                <p class="boldfont" v-else style="color:#F56C6C">已下架</p>
            </template>
        </el-table-column>
        <el-table-column label="状态" width="110">
            <template slot-scope="scope">
                <p class="boldfont" v-if="scope.row.status==0">正常</p>
                <p class="boldfont" v-if="scope.row.status==1" style="color:#F56C6C">已过期</p>
            </template>
        </el-table-column>
        <el-table-column prop="addTime" label="创建时间" width="180"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" width="180"></el-table-column>
        <el-table-column label="操作" fixed="right" min-width="400">
            <template slot-scope="scope">
            <el-button size="mini" type="warning" @click="handleEdit(2,scope.row,'coupons:receiveLog')"><i class="el-icon-document"></i> 领取记录</el-button>
            <el-button size="mini" type="primary" @click="handleEdit(3,scope.row,'coupons:useLog')"><i class="el-icon-document-delete"></i> 使用记录</el-button>
            <el-button size="mini" type="success" @click="handleEdit(1,scope.row,'coupons:update')"><i class="el-icon-edit"></i> 编辑</el-button>
            <el-button size="mini" type="danger" @click="stop(scope.row,'coupons:delete')"><i class="el-icon-delete"></i> 删除</el-button>
            </template>
        </el-table-column>
        </el-table>
        <div class="paging">
            <span>
            共
            <i class="pagingNum">{{total}}</i> 条
            </span>
            <Paging :gopage="total" @pag="pag"></Paging>
        </div>
    </el-card>
    <el-dialog :title="mydata.name" :visible.sync="dialogFormVisible" width="60%" @close="dataClose">
        <el-form>
            <div v-if='mydata.stat == 1||mydata.stat == 0'>
                <el-form-item label="* 所属地区：">
                    <el-select v-model="sheng" placeholder="省份" @change="cksheng">
                        <el-option
                        v-for="item in shenglist"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                    <el-select v-model="shi" placeholder="城市" @change="ckshi" class="cty16">
                        <el-option
                        v-for="item in shilist"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="* 优惠券介绍：">
                   <el-input placeholder="介绍" v-model="mydata.des" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="* 优惠券金额：">
                   <el-input placeholder="金额" v-model="mydata.discount" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="* 使用门槛金额：">
                   <el-input placeholder="金额" v-model="mydata.min" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="* 数 量：">
                   <el-input placeholder="数量" v-model="mydata.total" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="* 领取时间：">
                    <div class="block">
                        <el-date-picker align="right" :picker-options="pickerOptions" v-model="mydata.value1" type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间">
                        </el-date-picker>
                    </div>
                </el-form-item>
                <el-form-item label="* 使用时间：">
                    <div class="block">
                        <el-date-picker align="right" unlink-panels :picker-options="pickerOptions" v-model="mydata.value2" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间">
                        </el-date-picker>
                    </div>
                </el-form-item>
                <el-form-item label="* 是否上架：">
                    <el-radio v-model="mydata.isShelf" label=true>是</el-radio>
                    <el-radio v-model="mydata.isShelf" label=false>否</el-radio>
                </el-form-item>
            </div>
            <div v-else>
                <el-table :data="tableData2" border style="width: 100%">
                    <el-table-column type="index" label="序号" width="80" :index="1"></el-table-column>
                    <el-table-column v-if="mydata.stat == 2" prop="nickname" label="领取用户">
                    </el-table-column>
                    <el-table-column v-else prop="nickname" label="使用用户">
                    </el-table-column>
                    <el-table-column v-if="mydata.stat == 2" prop="addTime" label="领取时间">
                    </el-table-column>
                    <el-table-column v-else prop="usedTime" label="使用时间">
                    </el-table-column>
                </el-table>
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="puton" v-if="btnType == 0 || btnType == 1">确 定</el-button>
            <el-button type="primary" @click="dialogFormVisible = false" v-if="btnType == 2 || btnType == 3">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>
<script>
import Provinces from "@/components/Provinces";
import Reset from "@/components/Reset";
import Xlsx from "@/components/Xlsx";
import EditorBar from '@/components/Richtext'
import Paging from '@/components/Paging';
export default {
  name: "coupons",
  components: {
    Xlsx,
    EditorBar,
    Provinces,
    Reset,
    Paging
  },
  data() {
    return {
        beginData:{},
        tableData: [],
        tableData2:[],
        pageNum: 1,
        pageSize: 10,
        dialogFormVisible: false,
        userdata: {},
        total: 0,
        btn: [],
        fullscreenLoading: true,
        formname:JSON.stringify({name:'优惠券',hint:'coupons:export'}),
        sheng:'',
        shi:'',
        shenglist:[],
        shilist:[],
        mydata:{isShelf:'true'},
        multipleSelection:[],
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        // 确定按钮类型，0，1是新增和编辑，2，3是领取记录和使用记录
        btnType: 0,
    };
  },
  created() {
    let btn = JSON.parse(sessionStorage.getItem("btn"));
    this.$set(this, "btn", btn);
    this.begin();
  },
  computed: {
    data() {
      return this.tableData;
    }
  },
  mounted() {
    let region = JSON.parse(localStorage.getItem('region'))
    region.forEach(x => {
        if(x.level==0){
            this.shenglist.push(x)
            this.sheng=x.id
        }
    });
    if(this.userdata.level==0){
        this.$axios.post(`/api-r/area/getSubordinateAreaList`,this.$qs.stringify({areasId:region[0].id}),{headers:{accessToken:this.userdata.token}})
        .then(res=>{
            if(res.data.success){
                this.$set(this,'shilist',res.data.areaListInfoList)
            }
        })
    }else{
        region.forEach(x=>{
            if(x.level==1){
                this.shilist.push(x)
            }
        })
        if(this.shilist.length==1){
            this.shi=this.shilist[0].id
            this.mydata.areasId = this.sheng +','+ this.shilist[0].id
            this.mydata.areasName = this.userdata.areasName
        }
    }
  },
  methods: {
    resets(){
        this.$router.push('/refresh')
    },
    //   判断当前点击的按钮
    theBtn(i){
        if(i==1){
            if(this.btn.indexOf('coupons:add')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            this.handleEdit(0)
        }else if(i==2){
            if(this.btn.indexOf('coupons:update')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            if(this.multipleSelection.length != 1){
                return this.$message('请勾选一项内容编辑')
            }
            this.handleEdit(1,this.multipleSelection[0])
        }else if(i==3){
            if(this.btn.indexOf('coupons:delete')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            this.choice()
        }else if(i==4){
            this.query()
        }
    },
    // 获取省市传入的id
    gainSS(i){
        this.beginData.areaId = i.id
    },
    //   多选删除
    choice(){
        if(this.multipleSelection.length == 0){
            return this.$message('请至少选择一项删除')
        }
        let arr = []
        this.multipleSelection.forEach(x=>{
            arr.push(x.id)
        })
        this.$confirm('此操作将删除选中内容, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            let url = ``
            url = `/api-s/deleteCoupon/${arr.join(',')}`
            this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
            .then(res=>{
                if(res.data.success==true){
                    this.$message({
                        type: 'success',
                        message: res.data.msg
                    });
                    this.begin();
                }else{
                    alert(res.data.msg)
                }
            })
        }).catch(() => {
            return
        });
    },
    // 关闭清空内容
    dataClose(){
        if(this.shilist.length==1){
            this.mydata={isShelf:'true',areasId:this.sheng +','+ this.shilist[0].id,areasName:this.userdata.areasName}
        }else{
            this.shi = ''
            this.mydata={isShelf:'true'}
        }
    },
    cksheng(val){
        this.$set(this,'shi','')
    },
    ckshi(val){
        this.mydata.areasId = this.sheng +','+ val
        let arr = []
        this.shenglist.forEach(x=>{
            if(this.sheng==x.id){
                arr.push(x.name)
            }
        })
        this.shilist.forEach(x=>{
            if(val==x.id){
                arr.push(x.name)
            }
        })
        this.mydata.areasName = arr.join(',')
    },
    //   多选编辑
    handleSelectionChange(val) {
        this.multipleSelection = val;
    },
    //   确定
    puton(){
        if(this.mydata.areasId == undefined || this.mydata.areasId == ''){
            return this.$message.error('请选择所属地区')
        }
         if(!this.mydata.value1||!this.mydata.value2){
            return this.$message.error('请完善领取时间或使用时间')
        }
        if(!this.mydata.des || this.mydata.des == ""){
            return this.$message.error('请完善优惠券介绍')
        }
        if(!this.mydata.total || this.mydata.total == ""|| this.mydata.total == "0"){
            return this.$message.error('请完善数量且不能为0')
        }
        if(!this.mydata.discount||!this.mydata.min){
            return this.$message.error('请完善金额信息')
        }
        // if(!this.mydata.value1||!this.mydata.value2||!this.mydata.des||!this.mydata.min||this.mydata.total == ""||!this.mydata.discount){
        //     return this.$message('请完善必填信息')
        // }
        this.mydata.startTime = this.mydata.value2[0]
        this.mydata.endTime = this.mydata.value2[1]
        this.mydata.receiveStartTime = this.mydata.value1[0]
        this.mydata.receiveEndTime = this.mydata.value1[1]
        // 判断是点击哪个
        let url = ``
        this.fullscreenLoading = true;
        if(this.mydata.stat==0){
            url = `/api-s/addCoupon`
        }else if(this.mydata.stat==1){
            url = `/api-s/updateCoupon`
        }
        this.$axios.post(url,this.$qs.stringify(this.mydata),{ headers: { accessToken: this.userdata.token } })
        .then(res => {
            if(res.data.success){
                this.$message({
                    type: 'success',
                    message: res.data.msg
                });
                this.begin()
                this.dialogFormVisible = false
            }else{
                this.$message({
                    message:res.data.msg,
                    type: 'warning'
                })
            }
        });
    },
    pag(val){
        this.pageNum = val.pageNum
        this.pageSize = val.pageSize
        this.fullscreenLoading = true;
        this.begin();
    },
    begin() {
      let userdata = JSON.parse(sessionStorage.getItem("userdata"));
      this.$set(this, "userdata", userdata);
      let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        id:this.beginData.id,
        discount:this.beginData.discount,
        adminAreasId: userdata.areasId,
        areaId:this.beginData.areaId
      });
      this.$axios.post(`/api-s/getCouponList`, data, {headers: { accessToken: userdata.token }})
        .then(res => {
            this.fullscreenLoading = false;
            if(res.data.success){
                this.$nextTick(function(){  //不使用this.$nextTick()方法会报错
                    this.$set(this, "tableData", res.data.pageInfo.list);
                });
                this.$set(this, "total", res.data.pageInfo.total);
                this.$message({
                    type: 'success',
                    message: res.data.msg
                });
            }else{
              this.$message(res.data.msg)
            }
        });
    },
    handleEdit(i,row,hint) {
        this.btnType = i;
        if(hint&&this.btn.indexOf(hint)==-1){
            return this.$message('抱歉，用户暂无该权限')
        }
        if(i == 0){
            this.mydata.name = '添加优惠券'
            this.mydata.stat = i
        }else if(i == 1){
            row.name = '编辑优惠券'
            row.stat = i
            row.isShelf += ''
            this.sheng = Number(row.areasId.split(',')[0])
            this.shi = Number(row.areasId.split(',')[1])
            // row.value1 = [new Date(row.receiveStartTime),new Date(row.receiveEndTime)]
            // row.value2 = [new Date(row.startTime),new Date(row.endTime)]
            row.value1 = [row.receiveStartTime, row.receiveEndTime]
            row.value2 = [row.startTime, row.endTime]
            this.mydata = row
        }else{
            row.stat = i
            let url = ``
            if(i == 2){
                row.name = '领取记录'
                url = `/api-s/getCouponReceiveLogList/${row.id}`
            }else{
                row.name = '使用记录'
                url = `/api-s/getCouponUseLogList/${row.id}`
            }
            this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token } })
            .then(res => {
                if(i == 2){
                    this.tableData2 = res.data.couponReceiveLogInfos
                }else{
                    this.tableData2 = res.data.couponUseLogInfos
                }

            });
            this.mydata = row
        }
        // else{
        //
        // }
        this.dialogFormVisible = true
    },
    // 删除优惠券
    stop(row,hint) {
        if(hint&&this.btn.indexOf(hint)==-1){
            return this.$message('抱歉，用户暂无该权限')
        }
      this.$confirm('此操作将删除该条内容, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          let url = ``
          url = `/api-s/deleteCoupon/${row.id}`
          this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
          .then(res=>{
              if(res.data.success==true){
                  this.$message({
                      type: 'success',
                      message: res.data.msg
                  });
                  this.begin();
              }else{
                  alert(res.data.msg)
              }
          })
      }).catch(() => {
          return
      });
    },
    query() {
      this.fullscreenLoading = true;
      this.begin();
    }
  }
};
</script>
<style>
.w-e-toolbar{
  flex-wrap: wrap;
}
#coupons .el-input__inner {
  margin: 10px 0;
}
#coupons .el-menu.el-menu--horizontal{
  margin-bottom: 14px;
}
#coupons .el-menu-item.is-active{
  background: none
}
#coupons .el-pagination__sizes .el-input__inner {
  margin: 0;
}
#coupons .el-tag{
  margin-right: 12px;
}
#coupons .el-select {
  /* margin: 0 8px; */
  width: 50%
}
#coupons .block{
    width: 100%
}
#coupons .el-upload__tip {
    display: inline-block;
    margin-left: 14px;
}
.input-new-tag{
  width: 20%
}
#coupons .el-range-editor.el-input__inner{
    width: 100%
}
#coupons .el-upload-list--picture .el-upload-list__item {
    width: 44%;
    float: left;
    margin-right: 2%;
}
#coupons .el-form-item__content {
    width: 100%;
    display: flex;
}
#coupons .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
/* 暂无数据样式 */
#coupons .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
#coupons .myxx .el-input--suffix .el-input__inner {
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 20px;
}
#coupons .myxx .el-input__inner {
  padding: 0 11px;
  border: none;
  border-radius: 0;
}
#coupons .el-dialog__body {
  height: 100%;
}
#coupons .el-form-item{
    display: flex;
    align-items: center;
    margin-bottom:0
}
#coupons .el-form-item__label{
    width: 154px;
}
.viewer-transition {
  z-index: 9999 !important;
}
</style>
<style scoped lang="scss">
.clearfix{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.tit {
  display: flex;
  justify-content: space-between;
  margin: 16px 0 24px;
}
.sfzimg {
  height: 48px;
}
#help .myxx p {
  margin: 5px 0;
  font-size: 16px;
}
h5 {
  text-align: center;
  margin-top: 12px;
}
.f56 {
  background: #909399;
  color: #fff;
  border: 1px solid #909399;
}
.c23 {
  background: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
.tx{
      color: red;
    margin-left: 8px;
}
.summary>span:first-child{
    margin-right: 20px
}
.summary>span:first-child i{
    color:red
}
.summary>span:last-child i{
    color:green
}
.staimg{
    position: absolute;
    left: -26px;
    top: 10px;
    width: 18px;
}
.dtstat span{
    margin: 0 34px;
}
</style>
